import { useContext, useEffect, useState } from "react";
import Button1 from "../../../Button/Button1"
import { RuleProvider, useRule } from "./RuleReducer";
import ListOption from "../EditAutomations/ListOption";
import Button2 from "../../../Button/Button2";
import classes from '../CreateRule/SelectOutputs.module.css'
import ProgressBar from "./ProgressBar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import RoundedInput from "../EditAutomations/RoundedInput";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

const ChooseWhen = ({ navigate, backStep = 0 }) => {
    const { state, dispatch } = useRule(RuleProvider);
    const [disabled, setDisabled] = useState(true)
    const [progress, setProgress] = useState(40)
    const [showDayConditions, setShowDayConditions] = useState(false)
    const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];

    const currentCondition = state.conditions[state.conditionEditIndex];
    const [daysSelected, setDaysSelected] = useState(
        Array.isArray(currentCondition?.days_of_week)
            ? currentCondition.days_of_week
            : state.days_of_week
    )
    const [showTimeOptions, setShowTimeOptions] = useState(false)
    const [showDaysOptions, setShowDaysOptions] = useState(false)
    const [startTimeRaw, setStartTimeRaw] = useState()
    const [startTime, setStartTime] = useState()
    const [endTimeRaw, setEndTimeRaw] = useState()
    const [endTime, setEndTime] = useState()

    const [pinState, setPinState] = useState("")
    const [isAbsenceCondition, setIsAbsenceCondition] = useState(false)
    const [showAddAnotherDialog, setShowAddAnotherDialog] = useState(false)
    const [showTimeframe, setShowTimeframe] = useState(false)
    const [timeframeValue, setTimeframeValue] = useState("")
    const [timeframeUnit, setTimeframeUnit] = useState(60000)

    const timeframeUnitOptions = [
        { label: "Seconds", value: 1000 },
        { label: "Minutes", value: 60000 },
        { label: "Hours",   value: 3600000 },
    ]

    useEffect(() => {
    }, [])

    const HandleChooseWhenSelected = (selection) => {
        dispatch({ type: "SET_INPUT_TYPE", payload: selection })
        dispatch({ type: "SET_INPUT_TYPE_COPY", payload: selection })

        switch (selection) {
            case 0: setPinState("ARMED");    setIsAbsenceCondition(false); break;
            case 1: setPinState("ANY");      setIsAbsenceCondition(false); break;
            case 2: setPinState("DISARMED"); setIsAbsenceCondition(false); break;
            case 3: setPinState("ARMED");    setIsAbsenceCondition(true);  break;
            case 4: setPinState("DISARMED"); setIsAbsenceCondition(true);  break;
        }

        setDisabled(false)
    }

    useEffect(() => {
        const updatedCondition = state.conditions.map((condition, index) => {
            if (index === state.conditionEditIndex) {
                return {
                    ...condition,
                    days_of_week: JSON.stringify(daysSelected.map(Number)),
                    ...(startTime ? { time_window_start: startTime } : {}),
                    ...(endTime ? { time_window_end: endTime } : {}),
                    ...(endTime && startTime ? { time_condition: "DURING" } : {}),
                    pin_state: pinState,
                    is_absence_condition: isAbsenceCondition
                };
            }
            return condition;
        });

        dispatch({
            type: "SET_ADV_RULE_CONDITION",
            payload: updatedCondition
        });

    }, [pinState, isAbsenceCondition, startTime, endTime, daysSelected])

    const convertDaysOfTheWeek = () => {
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)
            .map(dayNumber => Days[dayNumber])
            .join(',');

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
            return "on weekends";
        } else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    }

    const HandleText = () => {
        let inputType;
        switch (state.inputTypeCopy) {
            case 0:
                inputType = `${state.pinStatusOn}`;
                if (state.isLock) {
                    inputType = "closed"
                }
                break;
            case 1:
                inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                if (state.isLock) {
                    inputType = "unlocked or closed"
                }
                break;
            case 2:
                inputType = `${state.pinStatusOff}`;
                if (state.isLock) {
                    inputType = "unlocked"
                }
                break;
            case 3:
                inputType = `${state.pinStatusOn}`;
                break;
            case 4:
                inputType = `${state.pinStatusOn}`;
                break;
            default:
                inputType = "unknown";
                break;
        }

        if (state.isPulse) {
            inputType = `temporarily ${state.pinStatusOff}`
        }

        if (state.days_of_week.length < 7) {
            return `Only when ${state.pinName} is ${inputType} ${convertDaysOfTheWeek()}`
        } else {
            return `When ${state.pinName} is ${inputType}`
        }
    }

    const HandleNavigate = (direction) => {
        if (direction === "back") {
            navigate(backStep)
        } else if (state.supportsAdvRules && !disabled) {
            setShowAddAnotherDialog(true)
        } else {
            navigate(2)
        }
    }

    const conditionSummaryText = () => {
        const cond = state.conditions[state.conditionEditIndex];
        if (!cond) return "";
        const pinLabel = cond.pin_name ?? `Pin ${cond.pin}`;
        return `${pinLabel} is ${conditionPinStateLabel(cond)}`;
    }

    const HandleOnDayClicked = (dayIndex) => {
        const isDayAlreayClicked = daysSelected.find(Day => Day == dayIndex);
        if (isDayAlreayClicked) {
            removeItem(dayIndex)
        } else {
            addItem(dayIndex)
        }
    }

    const addItem = (dayIndex) => {
        const newArray = [...daysSelected];
        newArray.push(dayIndex);
        setDaysSelected(newArray);
        dispatch({ type: "SET_EXECUTION_DAYS", payload: newArray });
    };

    const removeItem = (dayIndex) => {
        const newArray = [...daysSelected];
        const filterArray = newArray.filter(Day => Day !== dayIndex)
        setDaysSelected(filterArray);
        dispatch({ type: "SET_EXECUTION_DAYS", payload: filterArray });
    }

    const cancelTimeRestrictions = () => {
        setShowTimeOptions(false)
        setStartTime(null)
        setEndTime(null)
    }

    const conditionPinStateLabel = (cond) => {
        const prefix = cond.is_absence_condition ? "NOT " : "";
        switch (cond.pin_state) {
            case "ARMED": return `${prefix}active`;
            case "DISARMED": return `${prefix}inactive`;
            case "ANY": return "active or inactive";
            case "PULSE": return "triggered";
            default: return `${prefix}${cond.pin_state || "..."}`;
        }
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px", width: "80%" }}>

            <Dialog
                header="Condition added"
                visible={showAddAnotherDialog}
                style={{ width: "38vw" }}
                onHide={() => setShowAddAnotherDialog(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px", padding: "8px 0" }}>
                    <p style={{ color: "#6e6e6e", textAlign: "center", margin: 0 }}>
                        Condition set: <strong>{conditionSummaryText()}</strong>
                    </p>

                    {/* Optional timeframe — only relevant once a 2nd condition exists */}
                    {state.conditions.length > 1 && !showTimeframe ? (
                        <Button
                            label="Set timeframe between conditions (optional)"
                            icon="pi pi-clock"
                            severity="secondary"
                            outlined
                            onClick={() => setShowTimeframe(true)}
                        />
                    ) : state.conditions.length > 1 ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", width: "100%" }}>
                            <p style={{ color: "#6e6e6e", margin: 0, fontSize: "14px" }}>
                                All conditions must occur within:
                            </p>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <InputNumber
                                    value={timeframeValue === "" ? null : Number(timeframeValue)}
                                    onValueChange={(e) => {
                                        const val = e.value ?? "";
                                        setTimeframeValue(val);
                                        if (val !== "" && val > 0) {
                                            dispatch({ type: "SET_TIMEFRAME_WINDOW_MS", payload: Number(val) * timeframeUnit });
                                        } else {
                                            dispatch({ type: "SET_TIMEFRAME_WINDOW_MS", payload: null });
                                        }
                                    }}
                                    min={1}
                                    style={{ width: "100px" }}
                                    placeholder="e.g. 5"
                                />
                                <Dropdown
                                    value={timeframeUnit}
                                    options={timeframeUnitOptions}
                                    onChange={(e) => {
                                        setTimeframeUnit(e.value);
                                        if (timeframeValue !== "" && timeframeValue > 0) {
                                            dispatch({ type: "SET_TIMEFRAME_WINDOW_MS", payload: Number(timeframeValue) * e.value });
                                        }
                                    }}
                                    style={{ width: "130px" }}
                                />
                                <Button
                                    icon="pi pi-times"
                                    severity="secondary"
                                    text
                                    onClick={() => {
                                        setShowTimeframe(false);
                                        setTimeframeValue("");
                                        dispatch({ type: "SET_TIMEFRAME_WINDOW_MS", payload: null });
                                    }}
                                />
                            </div>
                            {timeframeValue !== "" && timeframeValue > 0 && (
                                <p style={{ color: "#9e9e9e", fontSize: "12px", margin: 0 }}>
                                    = {Number(timeframeValue) * timeframeUnit} ms
                                </p>
                            )}
                        </div>
                    ) : null}

                    <Divider style={{ margin: "4px 0" }} />
                    <p style={{ color: "#858585", textAlign: "center", margin: 0 }}>
                        Would you like to add another condition?
                    </p>
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <Button
                            label="No, continue"
                            icon="pi pi-arrow-right"
                            severity="success"
                            onClick={() => { setShowAddAnotherDialog(false); navigate(2); }}
                        />
                        <Button
                            label="Yes, add another"
                            icon="pi pi-plus"
                            severity="info"
                            onClick={() => { setShowAddAnotherDialog(false); navigate(9); }}
                        />
                    </div>
                </div>
            </Dialog>
            <ProgressBar progress={progress} />

            {/* Conditions summary — shown when multiple conditions exist */}
            {state.conditions.length > 1 && (
                <div style={{ width: "100%", padding: "10px 16px", background: "#f5f5f5", borderRadius: "8px", fontSize: "13px" }}>
                    <p style={{ color: "#6e6e6e", margin: "0 0 6px 0", fontWeight: 600 }}>Conditions:</p>
                    {state.conditions.map((cond, i) => (
                        <p key={i} style={{
                            margin: "3px 0",
                            color: i === state.conditionEditIndex ? "var(--Primary-Color)" : "#9e9e9e",
                            fontWeight: i === state.conditionEditIndex ? 600 : 400
                        }}>
                            {i === state.conditionEditIndex ? "▶" : "✓"} {i + 1}. {cond.pin_name ?? `Pin ${cond.pin}`} — {conditionPinStateLabel(cond)}
                        </p>
                    ))}
                </div>
            )}

            {/* AND / OR logic toggle — shown when multiple conditions exist */}
            {/* {state.conditions.length > 1 && (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center" }}>
                    <span style={{ color: "#6e6e6e", fontSize: "14px" }}>Logic:</span>
                    <Button2
                        style={{
                            minWidth: "70px",
                            minHeight: "36px",
                            backgroundColor: state.conditions_logic_operator === "AND" && "var(--Primary-Color)",
                            color: state.conditions_logic_operator === "AND" && "white",
                        }}
                        onClick={() => dispatch({ type: "SET_CONDITIONS_LOGIC_OPERATOR", payload: "AND" })}
                    >AND</Button2>
                    <Button2
                        style={{
                            minWidth: "70px",
                            minHeight: "36px",
                            backgroundColor: state.conditions_logic_operator === "OR" && "var(--Primary-Color)",
                            color: state.conditions_logic_operator === "OR" && "white",
                        }}
                        onClick={() => dispatch({ type: "SET_CONDITIONS_LOGIC_OPERATOR", payload: "OR" })}
                    >OR</Button2>
                </div>
            )} */}

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "20px" }}>
                <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
            </div>
            <h3 style={{ color: "#6e6e6e" }}>When will the rule trigger?</h3>
            <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "0px" }}>
                {!state.isPulse && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>

                    <Button2
                        style={{
                            minWidth: "300px",
                            minHeight: "50px",
                            backgroundColor: state.inputType == 0 && "var(--Primary-Color)",
                            color: state.inputType == 0 && "white",
                            border: state.inputType == 0 && "2px solid lightblue",
                            whiteSpace: "normal"
                        }}
                        onClick={() => HandleChooseWhenSelected(0)}
                    >
                        {!state.isLock ? (
                            <>When {state.pinName} is {state.pinStatusOn}</>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                                <span>When padlock is closed</span>
                                <span style={{ fontStyle: "italic", fontSize: "0.9em" }}>(Requires BLE Gateway)</span>
                            </div>
                        )}
                    </Button2>
                    <Button2
                        style={{
                            minWidth: "300px",
                            minHeight: "50px",
                            backgroundColor: state.inputType == 1 && "var(--Primary-Color)",
                            color: state.inputType == 1 && "white",
                            border: state.inputType == 1 && "2px solid lightblue",
                            whiteSpace: "normal"
                        }}
                        onClick={() => HandleChooseWhenSelected(1)}
                    >
                        {!state.isLock ? (
                            <>When {state.pinName} is {state.pinStatusOn} or {state.pinStatusOff}</>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                                <span>When padlock is unlocked or closed</span>
                                <span style={{ fontStyle: "italic", fontSize: "0.9em" }}>(Requires BLE Gateway)</span>
                            </div>
                        )}
                    </Button2>
                    <Button2
                        style={{
                            minWidth: "300px",
                            minHeight: "50px",
                            backgroundColor: state.inputType == 2 && "var(--Primary-Color)",
                            color: state.inputType == 2 && "white",
                            border: state.inputType == 2 && "2px solid lightblue",
                            whiteSpace: "normal"
                        }}
                        onClick={() => HandleChooseWhenSelected(2)}
                    >
                        {!state.isLock ? (
                            <>When {state.pinName} is {state.pinStatusOff}</>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                                <span>When padlock is unlocked</span>
                            </div>
                        )}
                    </Button2>
                    
                </div>}
                {state.isPulse &&
                    <Button2 style={{
                        minWidth: "450px",
                        minHeight: "50px",
                        backgroundColor: "var(--Primary-Color)",
                        color: "white",
                        border: "2px solid lightblue", minWidth: "300px"
                    }}>
                        {`When ${state.pinName} is temporarily ${state.pinStatusOff}`}
                    </Button2>
                }

<Divider type="solid" />
                {state.supportsAdvRules && !state.isPulse &&
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                        <Button2
                            style={{
                                minWidth: "300px",
                                minHeight: "50px",
                                backgroundColor: state.inputType == 3 && "var(--Primary-Color)",
                                color: state.inputType == 3 && "white",
                                border: state.inputType == 3 && "2px solid lightblue",
                                whiteSpace: "normal"
                            }}
                            onClick={() => HandleChooseWhenSelected(3)}
                        >
                            When {state.pinName} is NOT {state.pinStatusOn}
                        </Button2>
                        <Button2
                            style={{
                                minWidth: "300px",
                                minHeight: "50px",
                                backgroundColor: state.inputType == 4 && "var(--Primary-Color)",
                                color: state.inputType == 4 && "white",
                                border: state.inputType == 4 && "2px solid lightblue",
                                whiteSpace: "normal"
                            }}
                            onClick={() => HandleChooseWhenSelected(4)}
                        >
                            When {state.pinName} is NOT {state.pinStatusOff}
                        </Button2>
                    </div>
                }

                {state.supportsAdvRules &&
                    <div>
                        <div className={classes.verticalFlex}>
                            {showDaysOptions && <div><h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color: "#6e6e6e" }}>On:</h4>
                            <ul className={classes.horizontalFlex}>
                                {["0", "1", "2", "3", "4", "5", "6"].map((dayIndex, index) => (
                                    <li key={index}>
                                        <Button2 style={{ backgroundColor: daysSelected.find(Day => Day == dayIndex) && "var(--Primary-Color)", color: daysSelected.find(Day => Day == dayIndex) && "white", minWidth: "60px", minHeight: "30px" }} onClick={() => HandleOnDayClicked(dayIndex)}>{Days[dayIndex]}</Button2>
                                    </li>
                                ))}
                            </ul>
                            <br />
                            </div>}
                                <br/>
                            <Button visible={!showDaysOptions} label="Add days of the week restrictions?" severity="info" rounded icon="pi pi-plus" onClick={() => setShowDaysOptions(true)} />
                            <Button visible={!showTimeOptions} label="Add time restrictions?" severity="info" rounded icon="pi pi-plus" onClick={() => setShowTimeOptions(true)} />
                        </div>

                        {showTimeOptions &&
                            <div className={classes.verticalFlex} style={{ position: "relative" }}>
                                <div style={{ position: "absolute", left: "450px", bottom: "130px", textAlign: "center", borderRadius: "50%", border: "1px solid grey", width: "20px", height: "fit-content", cursor: "pointer" }} onClick={() => cancelTimeRestrictions()}>X</div>

                                <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color: "#6e6e6e" }}>Between:</h4>

                                <Calendar
                                    value={startTimeRaw}
                                    onChange={(e) => {
                                        const date = e.value;
                                        const hours = date.getHours().toString().padStart(2, "0");
                                        const minutes = date.getMinutes().toString().padStart(2, "0");
                                        setStartTime(`${hours}:${minutes}:00`);
                                        setStartTimeRaw(e.value)
                                    }}
                                    timeOnly
                                />
                                <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color: "#6e6e6e" }}>and</h4>
                                <Calendar
                                    value={endTimeRaw}
                                    onChange={(e) => {
                                        const date = e.value;
                                        const hours = date.getHours().toString().padStart(2, "0");
                                        const minutes = date.getMinutes().toString().padStart(2, "0");
                                        setEndTime(`${hours}:${minutes}:00`);
                                        setEndTimeRaw(e.value)
                                    }}
                                    timeOnly
                                />
                            </div>
                        }

                    </div>
                }
            </ul>
        </div>
    )
}

export default ChooseWhen;
